(function () {
  const modal = document.getElementById('fb-hs-modal');
  const openBtn = document.querySelector('[data-fb-hs-open]');
  const newsletterTarget = document.getElementById('fb-newsletter-form');
  const closeEls = modal.querySelectorAll('[data-fb-hs-close]');
  const dialog = modal.querySelector('.fb-hs-modal__dialog');

  let hsLoaded = false;
  let hsLoadingPromise = null;

  function loadHubSpot() {
    if (hsLoaded) return Promise.resolve();
    if (hsLoadingPromise) return hsLoadingPromise;

    hsLoadingPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/embed/v2.js';
      script.async = true;
      script.onload = () => {
        hsLoaded = true;
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return hsLoadingPromise;
  }

  function ensureForm() {
    const target = document.getElementById('fb-hs-form');
    if (!target) return;
    if (target.dataset.hsRendered === 'true') return;

    if (!window.hbspt || !window.hbspt.forms || !window.hbspt.forms.create) return;

    window.hbspt.forms.create({
      region: 'na1',
      portalId: '39889726',
      formId: '47ae7a03-1bb9-4225-b8d8-01fc592d80e1',
      target: '#fb-hs-form'
    });

    target.dataset.hsRendered = 'true';
  }

  function ensureNewsletterForm() {
    if (!newsletterTarget) return;
    if (newsletterTarget.dataset.hsRendered === 'true') return;
    if (!window.hbspt || !window.hbspt.forms || !window.hbspt.forms.create) return;

    window.hbspt.forms.create({
      region: 'na1',
      portalId: '39889726',
      formId: '34fae30a-1750-4333-891e-fcf890cbdc79',
      target: '#fb-newsletter-form'
    });

    newsletterTarget.dataset.hsRendered = 'true';
  }

  function openModal() {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('fb-hs-modal-open');

    loadHubSpot()
      .then(() => {
        // wait a tick for HubSpot to attach
        setTimeout(ensureForm, 0);
      })
      .catch(() => {
        // no-op: modal still opens
      });

    // focus management
    if (dialog) {
      dialog.setAttribute('tabindex', '-1');
      dialog.focus({ preventScroll: true });
    }
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fb-hs-modal-open');
    if (openBtn) openBtn.focus({ preventScroll: true });
  }

  document.querySelectorAll('[data-fb-hs-open]').forEach((btn) => {
    btn.addEventListener('click', openModal);
  });

  closeEls.forEach((el) => el.addEventListener('click', closeModal));


  document.querySelectorAll('[data-fb-copy-link]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const url = btn.getAttribute('data-copy-url');
      if (!url) return;
      try {
        await navigator.clipboard.writeText(url);
        const original = btn.innerHTML;
        btn.innerHTML = '<span aria-hidden="true">✓</span>';
        setTimeout(() => {
          btn.innerHTML = original;
        }, 1400);
      } catch (_) {
        window.prompt('Copy this link:', url);
      }
    });
  });


  document.querySelectorAll('.template-product .header-logo a, .template-product .header-logo, .template-product .header__heading-link, .template-collection .header-logo a, .template-collection .header-logo, .template-collection .header__heading-link').forEach((el) => {
    if (el.tagName === 'A') {
      el.setAttribute('href', 'https://www.fundraiserblankets.com');
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener');
    }
  });

  if (newsletterTarget) {
    loadHubSpot().then(() => setTimeout(ensureNewsletterForm, 0)).catch(() => {});
  }

  function initCartDrawerBackdropClose() {
    document.querySelectorAll('.template-product .cart-drawer__dialog, .template-collection .cart-drawer__dialog').forEach((dialogEl) => {
      if (dialogEl.dataset.fbOutsideCloseBound === 'true') return;
      dialogEl.dataset.fbOutsideCloseBound = 'true';

      dialogEl.addEventListener('click', (event) => {
        const inner = dialogEl.querySelector('.cart-drawer__inner');
        if (!inner) return;
        if (event.target === dialogEl || !inner.contains(event.target)) {
          const drawer = document.querySelector('.template-product cart-drawer-component, .template-collection cart-drawer-component');
          if (drawer && typeof drawer.close === 'function') {
            drawer.close();
          } else {
            const closeBtn = dialogEl.querySelector('.cart-drawer__close-button');
            closeBtn && closeBtn.click();
          }
        }
      });
    });
  }

  initCartDrawerBackdropClose();

  document.addEventListener('click', (event) => {
    const dialogEl = document.querySelector('.template-product .cart-drawer__dialog[open], .template-collection .cart-drawer__dialog[open]');
    const inner = dialogEl && dialogEl.querySelector('.cart-drawer__inner');
    if (!dialogEl || !inner) return;
    if (event.target === dialogEl) return;
    if (!inner.contains(event.target) && !event.target.closest('[data-testid="cart-drawer-trigger"]')) {
      const drawer = document.querySelector('.template-product cart-drawer-component, .template-collection cart-drawer-component');
      if (drawer && typeof drawer.close === 'function') {
        drawer.close();
      }
    }
  }, true);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
})();
